export const NEW_CONDITION_ID = 'new';
export const USED_CONTIDION_ID = 'used';
